export default {
  common: {
    nav: {
      home: "മുഖ്യപേജ്",
      find_offer_help: "സഹായം കണ്ടെത്തുക / നൽകുക",
      celebrate: "ജീവിതം ആഘോഷിക്കുക",
      family_tree: "കുടുംബ വൃക്ഷം",
      events: "ഇവന്റുകൾ",
      civic_reports: "പൗര റിപ്പോർട്ടുകൾ",
      neighborhood_pulse: "അയൽപക്ക സ്പന്ദനം",
      weather: "കാലാവസ്ഥ",
      nature: "പ്രകൃതി",
      marketplace: "മാർക്കറ്റ്",
      news: "വാർത്തകൾ",
      causes: "ലക്ഷ്യങ്ങൾ",
      more: "കൂടുതൽ",
    },
    header: { sign_in: "സൈൻ ഇൻ", join: "Social Pulse ൽ ചേരുക", language: "ഭാഷ", search: "തിരയുക" },
    tagline: "സമൂഹങ്ങളെ ബന്ധിപ്പിക്കുന്നു · ജീവിതത്തിന് ശക്തി പകരുന്നു · സാമൂഹിക മൂലധനം കെട്ടിപ്പടുക്കുന്നു",
    locality: { viewing_from: "നിങ്ങൾ കാണുന്നത്", change: "മാറ്റുക", set_your_location: "നിങ്ങളുടെ സ്ഥാനം സജ്ജമാക്കുക" },
    news: { title: "നിങ്ങളുടെ ദിനംപ്രതി വാർത്താസംഗ്രഹം.", play_briefing: "ദിനംപ്രതി വാർത്ത കേൾക്കുക", listen: "കേൾക്കുക", translate: "വിവർത്തനം ചെയ്യുക" },
  },
};
